import { React } from "react";
import ConsultantsContent from "../../Component/Consultants/ConsultantsContent";

function Consultants() {
  return  <ConsultantsContent />
     
}

export default Consultants;
